import _classCallCheck from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as Mat3Func from './functions/Mat3Func.js';
export var Mat3 = /*#__PURE__*/function (_Array) {
  _inherits(Mat3, _Array);

  var _super = _createSuper(Mat3);

  function Mat3() {
    var _this;

    var m00 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var m01 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var m02 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var m10 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var m11 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var m12 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var m20 = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var m21 = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var m22 = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1;

    _classCallCheck(this, Mat3);

    _this = _super.call(this, m00, m01, m02, m10, m11, m12, m20, m21, m22);
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Mat3, [{
    key: "set",
    value: function set(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
      if (m00.length) return this.copy(m00);
      Mat3Func.set(this, m00, m01, m02, m10, m11, m12, m20, m21, m22);
      return this;
    }
  }, {
    key: "translate",
    value: function translate(v) {
      var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      Mat3Func.translate(this, m, v);
      return this;
    }
  }, {
    key: "rotate",
    value: function rotate(v) {
      var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      Mat3Func.rotate(this, m, v);
      return this;
    }
  }, {
    key: "scale",
    value: function scale(v) {
      var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      Mat3Func.scale(this, m, v);
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(ma, mb) {
      if (mb) {
        Mat3Func.multiply(this, ma, mb);
      } else {
        Mat3Func.multiply(this, this, ma);
      }

      return this;
    }
  }, {
    key: "identity",
    value: function identity() {
      Mat3Func.identity(this);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(m) {
      Mat3Func.copy(this, m);
      return this;
    }
  }, {
    key: "fromMatrix4",
    value: function fromMatrix4(m) {
      Mat3Func.fromMat4(this, m);
      return this;
    }
  }, {
    key: "fromQuaternion",
    value: function fromQuaternion(q) {
      Mat3Func.fromQuat(this, q);
      return this;
    }
  }, {
    key: "fromBasis",
    value: function fromBasis(vec3a, vec3b, vec3c) {
      this.set(vec3a[0], vec3a[1], vec3a[2], vec3b[0], vec3b[1], vec3b[2], vec3c[0], vec3c[1], vec3c[2]);
      return this;
    }
  }, {
    key: "inverse",
    value: function inverse() {
      var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      Mat3Func.invert(this, m);
      return this;
    }
  }, {
    key: "getNormalMatrix",
    value: function getNormalMatrix(m) {
      Mat3Func.normalFromMat4(this, m);
      return this;
    }
  }]);

  return Mat3;
}( /*#__PURE__*/_wrapNativeSuper(Array));